import type { ListenerMiddlewareInstance } from "@reduxjs/toolkit";

import { createAndSendEvent } from "@chef/events";
import { invariant } from "@chef/utils/invariant";

import {
  CampaignCartModalParams,
  DeviationCartModalParams,
  ModalData,
  openModal,
  RootState,
  SubscriptionCartModalParams,
} from "..";

function isCartModalParams(
  payload: ModalData,
): payload is
  | SubscriptionCartModalParams
  | DeviationCartModalParams
  | CampaignCartModalParams {
  return (
    payload.id === "SUBSCRIPTION_CART" ||
    payload.id === "DEVIATION_CART" ||
    payload.id === "CAMPAIGN_CART"
  );
}

export default (listener: ListenerMiddlewareInstance) =>
  listener.startListening({
    actionCreator: openModal,
    effect: async (action, listenerApi) => {
      const state = listenerApi.getState() as RootState;

      if (!isCartModalParams(action.payload)) {
        return;
      }

      const week = action.payload["week"];
      const year = action.payload["year"];

      const deviation = state.basket.deviations.find(
        (d) => d.week === week && d.year === year,
      );

      invariant(deviation, "Could not find deviation");

      createAndSendEvent("Cart Viewed", {
        affiliation: "Frontend process",
        products: deviation.products.map((bp) => ({
          product_id: bp.productId,
          variant_id: bp.variationId,
          quantity: bp.quantity,
          price: bp.price,
          category_id: bp.productTypeId,
        })),
      });
    },
  });
